export const isTestRunner =
  !!window.navigator.userAgent.match(/StorybookTestRunner/);
